import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import SidenavContent from './SidenavContent';
import {toggleCollapsedNav, updateWindowWidth} from 'actions/Setting';

class SideNav extends React.PureComponent {

    componentDidMount() {
        window.addEventListener('resize', () => {
            this.props.updateWindowWidth(window.innerWidth)
        });

        setTimeout(() => {
            this.setNavbarHeight();
        },1200);
    }

    componentDidUpdate() {
        setTimeout(() => {
            this.setNavbarHeight();
        },1200);
    }
    onToggleCollapsedNav = () => {
        this.props.hide_drawer()
    };

    setNavbarHeight () {
        let navBar = document.getElementById('sidebar-nav');
        if(window.innerHeight <= 450) {
            const contentHeight = document.getElementById('app-main-content-wrapper').offsetHeight;
            navBar.style.height = contentHeight+'px';
        } else if(navBar && navBar.style) {
            navBar.style.height = '100%';
        }
    }

  render() {
    const {
        user_sign_out} = this.props; 
      return (
            <SidenavContent user_sign_out={user_sign_out} />
      )
  }
}

const mapStateToProps = ({settings}) => {
  const {navCollapsed, drawerType, width, navigationStyle} = settings;
  return {navCollapsed, drawerType, width, navigationStyle}
};

export default withRouter(connect(mapStateToProps, {toggleCollapsedNav, updateWindowWidth})(SideNav));

